/**
 * Comparison Card Scroll - Custom element for horizontal scroll with progress bar.
 * Used on mobile to track scroll position of the comparison card.
 */
class ComparisonCardScroll extends HTMLElement {
  connectedCallback() {
    this.scrollContainer = this.querySelector('[ref="scrollContainer"]');
    this.progressThumb = this.querySelector('[ref="progressThumb"]');
    this.progressBar = this.querySelector('[ref="progressBar"]');

    if (!this.scrollContainer || !this.progressThumb) return;

    this.onScroll = () => this.updateProgress();
    this.scrollContainer.addEventListener('scroll', this.onScroll, { passive: true });

    if (typeof ResizeObserver !== 'undefined') {
      this.resizeObserver = new ResizeObserver(() => this.updateProgress());
      this.resizeObserver.observe(this.scrollContainer);
    }

    this.updateProgress();
  }

  disconnectedCallback() {
    if (this.scrollContainer && this.onScroll) {
      this.scrollContainer.removeEventListener('scroll', this.onScroll);
    }
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  }

  updateProgress() {
    const { scrollLeft, scrollWidth, clientWidth } = this.scrollContainer;
    const maxScroll = scrollWidth - clientWidth;

    // Hide progress bar if content doesn't overflow
    if (maxScroll <= 0) {
      if (this.progressBar) this.progressBar.style.display = 'none';
      return;
    }

    // Show progress bar when content overflows
    if (this.progressBar) this.progressBar.style.removeProperty('display');

    const progress = Math.min(scrollLeft / maxScroll, 1);
    // Fill width from minimum to 100% based on scroll progress
    const minWidth = 20; // minimum width percentage when at start
    const fillPercent = minWidth + progress * (100 - minWidth);

    this.progressThumb.style.width = `${fillPercent}%`;
  }
}

if (!customElements.get('comparison-card-scroll')) {
  customElements.define('comparison-card-scroll', ComparisonCardScroll);
}
